import axios from 'axios';

const api = axios.create({
    baseURL: 'https://vast-escarpment-91874.herokuapp.com/',
})

export default api;